import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import getters from './getters'
import bundles from './modules/bundles.js'
import mutations from './mutations'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    view: '',
    bearhouse: ['853384435005817'],
    gbpayment: ['998122266996445'],
    theme2c2p: ['tero'],
    page2c2p: [
      '105516258950290', //TEST - Central
      '110710877332627',
      '160733491520',
      '107235216024674',
      '103551424764072',
      '112085313900804',
      '102421048239798',
      '105928254552462',
      '114621593252079',
      '115414076948160', //test 2c2p
      '392612533487',
      '104716585038207',
      '362065616073'
      // '108234815144840', // test nestle
      // '1037700739663223', // nestle
      // '110981841237323', // nestle
      // '101542172593323' // test nestle
    ],
    cds: [
      '105516258950290',
      '110710877332627',
      '160733491520',
      '107235216024674',
      '394274810994296',
      '103551424764072',
      '392612533487',
      '11462159325207',
      '114621593252079',
      '112085313900804',
      '102421048239798',
      '105928254552462',
      '134297248716',
      '408054729252920',
      '122424499005',
      '634199670052309',
      '460631194141528',
      '291451944586723',
      '102855154730088',
      '1322459104509147',
      '100169865799063'
    ],
    newCentralPage: [
      '105516258950290',
      '102855154730088', //Central Department Store CentralFestival Hadyai
      '1322459104509147', //Central Department Store Khonkaen
      '634199670052309', //Robinson CentralPlaza Ubonratchathani
      '460631194141528', //Robinson Department Store Hatyai
      '291451944586723', // Robinson Department Store Suratthani
      '110710877332627',
      '100169865799063',
      '108631281736526',
      '160733491520',
      '107235216024674',
      '394274810994296',
      '392612533487',
      '103551424764072',
      '11462159325207',
      '114621593252079',
      '112085313900804',
      '134297248716',
      '408054729252920',
      '122424499005',
      '102421048239798',
      '105928254552462'
    ],
    // cds: [],
    //  '394274810994296', //moo
    khaiwhan: ['103617407715034'],
    ros: ['113937150302402'],
    loadingCart: undefined,
    cart: [],
    cart_ids: [],
    kullastripage: ['103669308635970'],
    bscpage: ['102944058709341'],
    isWholesale: false,
    wholesale: [],
    theme: {
      color: '#cecece'
    },
    pageProfile: undefined,
    salePage: null,
    loadingPageProfile: true,
    allowProductRemark: ['102434044554028'],
    modalProductLarge: ['100650749519377'],
    influencerid: localStorage.getItem('influencerid')
      ? localStorage.getItem('influencerid')
      : null,
    notShowWeight: ['485851741439218', '104378617963897'],
    kipCurrency: ['1686626471624369'],
    usdCurrency: [
      '402026927063253',
      '100855246124906',
      '105757739112608',
      '100203512915939',
      '111151505282962'
    ],
    myanmarCurrency: ['751241271893504'],
    wonCurrency: ['956547031072669'],
    poundCurrency: ['101825731873998'],
    tkBangladeshCurrency: ['109436512005912'],
    thpostmartVerifyCartResult: null,
    shop_main_pageid: null,
    vouchers: [],
    hasAutoSelectVoucher: false,
    tremendousMemberInfo: null,
    paymentGateways: [],
    paysolutionCustomerData: undefined,
    paymentGatewayData: undefined
  },
  mutations,
  actions,
  getters,
  modules: {
    bundles
  }
})
